const base = require('base/product/base');
const detail = require('base/product/detail');
const tile = require('pluggin_variable_weight/product/tile');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    return $($el).closest('.add-to-cart').data('pid');
}

/**
 * Retrieves url to use when adding a product to the cart
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl($el) {
    return $($el).closest('.add-to-cart').data('endpoint-add-to-cart');
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.choice-of-bonus-product');
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    const htmlString = `${'<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="'}${data.maxBonusItems}"` +
        `data-UUID="${data.uuid}"` +
        `data-pliUUID="${data.pliUUID}"` +
        `data-addToCartUrl="${data.addToCartUrl}"` +
        'data-pageStart="0"' +
        `data-pageSize="${data.pageSize}"` +
        `data-moreURL="${data.showProductsUrlRuleBased}"` +
        `data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">` +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        `    <span class="">${data.labels.selectprods}</span>` +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success(response) {
            const parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {jquery} el - DOM container for a given add to cart button
 */
function handlePostCartAdd(response, el) {
    $('.minicart').trigger('count:update', response);
    if (response && response.cart && response.cart.items) {
        const pid = el.closest('.add-to-cart').data('pid');
        const products = response.cart.items.filter((item) => item.id === pid);
        if (products && products.length > 0) {
            var product = products.pop();

            // Veficar que esta en detailsPDP para ver si va con el sticky, para modificar los dos
            const isInDetailsPDP = el.closest('.detailsPDP').length > 0;

            if (isInDetailsPDP) {
                // Modificamos los dos elementos .add-to-cart dentro de .detailsPDP que serían el propio de la PDP y el sticky
                $('.detailsPDP .add-to-cart').each(function () {
                    const buttonContainer = $(this);

                    buttonContainer.find('.btn-add-to-cart').removeClass('show');
                    buttonContainer.find('.update-quantity').addClass('show');
                    if (product.variableWeight) {
                        buttonContainer.find('.update-quantity .quantity').html(Number(product.unitData.value).toFixed(2).toString().replace('.', ','));
                    } else {
                        buttonContainer.find('.update-quantity .quantity').html('1');
                    }
                });
            } else {
                // Modifica el boton .add-to-cart donde se hizo clic
                el.closest('.add-to-cart').find('.update-quantity').addClass('show');
                if (product.variableWeight) {
                    el.closest('.add-to-cart').find('.update-quantity .quantity').html(Number(product.unitData.value).toFixed(2).toString().replace('.', ','));
                } else {
                    el.closest('.add-to-cart').find('.update-quantity .quantity').html('1');
                }
                el.removeClass('show');
            }
        }
    }

    const messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages d-none d-md-block"></div>');
        }

        $('.add-to-cart-messages').append(`<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">${
            response.message
        }</div>`);

        setTimeout(() => {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url,
            method: 'GET',
            success() {
                // reporting urls hit on the server
            },
            error() {
                // no reporting urls hit on the server
            },
        });
    }
}

/**
 * Makes a CSRF-token research in the twolineheader element to fill the product-notes-form
 * Deletes the previous csrf_token if already exists
 */
function fillCSRFToken(modalForm) {
    var csrfTokenName = $('#customerConnectTk input[type="hidden"]').attr('name');
    var csrfTokenValue = $('#customerConnectTk input[type="hidden"]').val();

    if (csrfTokenName && csrfTokenValue) {
        var notesForm = $('.formnotes-container');

        if (notesForm.length) {
            // Eliminar cualquier input existente con el nombre CSRF para evitar duplicados
            notesForm.find('input[name="' + csrfTokenName + '"]').remove();

            // Creación del nuevo input con el token actualizado
            var csrfInput = $('<input>', {
                type: 'hidden',
                name: csrfTokenName,
                value: csrfTokenValue
            });

            // Añadir el nuevo input CSRF dentro del formulario
            notesForm.append(csrfInput);
        }
    }
}

module.exports = {
    // Exportar detalles con extensión de configuraciones base y de detalle
    exportDetails: $.extend({}, base, detail, {}),

    // Ir a addToCart de la Tile
    addToCart: tile.addToCart(),

    // Actualizar cantidad en el carrito
    updateQuantityCart: tile.updateQuantityCart(),

    // Actualizar el minicart
    updateMinicart() {
        $('body').on('cart:update', () => {
            tile.updateQuantities();
        });
    },

    // Cargar productos y actualizar cantidades
    productLoad: tile.updateQuantities(),

    // Actualizar cantidades en recomendaciones de productos
    updateProductRecommendationsQuantities() {
        const targetNodeList = document.getElementsByClassName("recommendations");

        if (targetNodeList.length > 0) {
            const targetNode = targetNodeList[0];
            const config = { attributes: false, childList: true, subtree: true };

            const callback = (mutationList, observer) => {
                for (const mutation of mutationList) {
                    if (mutation.type === "childList" && document.querySelector(".recommendations .product-tile") !== null) {
                        observer.disconnect();
                        tile.updateQuantities();
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    },

    // Show nav-items with product information (general, detail, nutritional info)
    showInfoTab() {
        $(document).ready(function () {

            function showTab(tabId) {
                $('.tab-content').addClass('d-none');
                $('.nav-link').removeClass('active');
            
                $('#' + tabId).removeClass('d-none');
                $('.nav-link[data-tab="' + tabId + '"]').addClass('active');
            }
            
            function checkTabsAndShow() {
                if ($('#general').children().length > 0 && $('#general').text().trim() !== '') {
                    showTab('general');
                }
                else if ($('#details').children().length > 0 && $('#details').text().trim() !== '') {
                    showTab('details');
                }
                else if ($('#nutritionalInfo').children().length > 0 && $('#nutritionalInfo').text().trim() !== '') {
                    showTab('nutritionalInfo');
                }
                else {
                    showTab('noProductInfo');
                    $('.nav-link[data-tab="general"], .nav-link[data-tab="details"], .nav-link[data-tab="nutritionalInfo"]').addClass('disabled').removeClass('active');
                }
            }
            
            $('.nav-link').on('click', function () {
                const tabId = $(this).data('tab');
                if (!$(this).hasClass('disabled')) {
                    showTab(tabId);
                }
            });
            
            checkTabsAndShow();
        });
    },
    notesTokenModalEvent() {
        $(document).ready(function () {
            fillCSRFToken();
        })
    },


};
